import React, { useState } from 'react';
import Button from './baseButton';
import customIcons from '../../utils/icons';
import downloadFromUrl from '../../utils/downloadFromUrl';
import { ComponentProps } from '../../types/core.type';

type DownloadButtonProps = ComponentProps & {
  label?: string;
  fetchUrl: () => Promise<string>;
};

export default function DownloadButton({
  id = '',
  className = '',
  label = 'Export CSV',
  fetchUrl,
}: DownloadButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    setIsLoading(true);
    await downloadFromUrl(fetchUrl);
    setIsLoading(false);
  };

  return (
    <Button
      id={`${id}-download-button`}
      className={className}
      onClick={handleDownload}
    >
      {isLoading
        ? <span className="mx-1">Loading...</span> : (
          <>
            <i>{customIcons.downloadIcon}</i>
            <span className="mx-1">{label}</span>
          </>
        )}
    </Button>
  );
}
